import { useMemo, useState } from "react";
import { StreamingInterval } from "@arelia-types/streaming";
import StreamingChartPresenter from "./StreamingChartPresenter";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import { useChartStreams } from "../../api/streaming";
import { useChartDataArtistFilter } from "@arelia-hooks/artistAccount";
import { combineChartData } from "@arelia-utils/helpers/chartsData";
import { formatDate } from "@arelia-utils/helpers/dates";

export default function StreamsContainer() {
  const [period, setPeriod] = useState(StreamingInterval.daily);
  const requiredConnectionNames = [ConnectionName.youtube, ConnectionName.spotify, ConnectionName.amazon, ConnectionName.appleMusic, ConnectionName.pandora];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);

  const { data, isLoading, isError } = useChartStreams(period, { enabled: hasRequiredConnections });
  const filteredData = useChartDataArtistFilter(data);

  const chartData = useMemo(
    () => {
      if (!filteredData) return { labels: [], data: [], datasets: [] };
      const dateFormat = period !== StreamingInterval.monthly ? 'LLL dd' : 'LLL yyyy';
      const { labels, data } = combineChartData(filteredData);

      return {
        datasets: filteredData.map(x => x.networkName),
        labels: labels.map(l => formatDate(l, dateFormat)),
        data
      };
    },
    [filteredData]
  );

  return <StreamingChartPresenter
    widgetId='STREAMS'
    title='Streams'
    chartListeners={chartData}
    loading={isLoading}
    error={isError}
    period={period}
    unconnected={!hasRequiredConnections}
    setPeriod={setPeriod}
  />;
}
